export default __webpack_public_path__ + "static/media/stripe.3d3e8fc3.png";